<!-- @format -->

<template>
	<div>
		<layout-default-new>
			<section>
				<!-- <b-field class="margin-top-20" label="Select report date">
					<b-datepicker
						v-model="reportData.beginningDate"
						:show-week-number="showWeekNumber"
						:locale="locale"
						:first-day-of-week="firstDayOfWeek"
						placeholder="Click to select..."
						icon="calendar-today"
						trap-focus
					>
					</b-datepicker>
				</b-field> -->
				<b-field label="Select report date">
					<b-datepicker
						v-model="reportData.endingDate"
						:show-week-number="showWeekNumber"
						:locale="locale"
						:first-day-of-week="firstDayOfWeek"
						placeholder="Click to select..."
						icon="calendar-today"
						trap-focus
					>
					</b-datepicker>
				</b-field>
				<b-field label="Report Type">
					<section>
						<div class="block">
							<b-radio
								v-model="radio"
								name="name"
								native-value="collectedPaymentReport"
							>
								Inbetalningar
							</b-radio>
							<b-radio v-model="radio" name="name" native-value="setOffReport">
								Övriga - Kivitteringar
							</b-radio>
						</div>
						<p class="content">
							<b>Selection:</b>
							{{ radio }}
						</p>
					</section>
				</b-field>
				<b-button
					class="is-primary margin-top-20 margin-bottom-20"
					style="width: 500px"
					type="submit"
					@click="getData"
					>Show payments that will be added to the report (Refresh)</b-button
				>
				<div v-if="loading">Loading......</div>
				<b-table
					:data="tableData"
					:columns="columns"
					class="smallFonts tale-style margin-top-15"
				>
				</b-table>
				<div>
					<b-button
						class="is-success margin-top-30 margin-bottom-30"
						style="width: 500px"
						type="submit"
						:disabled="disabledButton"
						@click="createHeader"
					>
						Create Collected Payments Report for the date
						{{ dateformat(reportData.endingDate, 'yyyy-mm-dd') }}</b-button
					>
				</div>
			</section>
		</layout-default-new>
	</div>
</template>

<script>
import CreateCollectPaymentReportHeaderMutation from '@/_srcv2/pages/accounting/page-create-collected-payments-report/graphql/mutation/createCollectPaymentReportHeader.mutation.gql'
import GetCollectedPaymentsListToViewQuery from '@/_srcv2/pages/accounting/page-create-collected-payments-report/graphql/query/getCollectedPaymentsListToView.query.gql'
import UpdateBookKeepHeadersTableInsertReportNumberMutation from '@/_srcv2/pages/accounting/page-create-collected-payments-report/graphql/mutation/updateBookKeepHeadersTableInsertReportNumber.mutation.gql'
import { useMutation, useQuery } from '@vue/apollo-composable'
import {
	computed,
	reactive,
	ref,
	onMounted,
	watchEffect,
} from '@vue/composition-api'
import Store from '@/store'
import dateformat from 'dateformat'
import useReportNumber from '@/_srcv2/views/_shared/_composables/format-report-numbers/useReportNumber'
import storeAccounting from '@/_srcv2/pages/accounting/accounting-store/storeAccounting.js'
import Router from '@/router'

export default {
	name: 'CreateCollectedPaymentsReport',
	setup() {
		const radio = ref('collectedPaymentReport')
		const reportType = computed(() => radio.value)
		const { reportHeaders, reportData } = storeAccounting()
		const showWeekNumber = false
		const locale = 'sv-SE'

		const queryVariables = reactive({
			ed: computed(() => {
				return dateformat(reportData.endingDate, 'yyyy-mm-dd')
			}),
			our_company: Store.getters.getUserCurrentCompany,
			report_type: computed(() => {
				return radio.value
			}),
		})

		console.log('queryVariables on created', queryVariables)

		console.log('CreateCollectedPaymentsReport is created')
		console.log('Date', dateformat(reportData.endingDate, 'yyyy-mm-dd'))
		onMounted(() => {
			console.log('queryVariables on mounted', queryVariables)
			setInitialState()
			refetch()
		})
		const setInitialState = () => {
			reportHeaders.tableLinesSubLines = []
			reportHeaders.countTransactions = 0
			reportHeaders.creditAmount = 0
			reportHeaders.creditExchangeAmount = 0
			reportHeaders.coverLines = []
			reportHeaders.coverDebitTotals = 0
			reportHeaders.coverCreditTotals = 0
			reportHeaders.docDefinition = []
			reportHeaders.reportDate = dateformat(reportData.endingDate, 'yyyy-mm-dd')
			reportHeaders.reportType = 'Inbetalningsjournal nr.'
			reportHeaders.reportNumber = 0
			reportHeaders.ourCompany = ''
			reportHeaders.coverTitle = 'Bokföringsunderlag'
			radio.value = 'collectedPaymentReport'
		}

		// Get daily payments for view
		const options = reactive({
			fetchPolicy: 'no-cache',
		})

		const { loading, refetch, onResult } = useQuery(
			GetCollectedPaymentsListToViewQuery,
			() => queryVariables,
			options,
		)
		const { floatedCurrencyAddedNumber } = useReportNumber()

		const bookKeepIdsArray = ref([])

		const columns = [
			{
				field: 'date',
				label: 'Datum',
				width: '120',
			},
			{
				field: 'documentNumber',
				label: 'Dokument Nr.',
				width: '120',
			},
			{
				field: 'companyId',
				label: 'Kundnummer',
				width: '120',
			},
			{
				field: 'companyTitle',
				label: 'Kundnamn',
				width: '120',
			},
			{
				field: 'paymentAmount',
				label: 'Bellop',
				width: '120',
			},
			{
				field: 'type',
				label: 'Typ',
				width: '70',
			},
		]
		const tableData = ref([])
		const getData = () => {
			console.log('getData is fired')
			refetch()
		}

		onResult((result) => {
			console.log('queryVariables onResult', queryVariables)
			console.log('onResult is fired')
			console.log('Result', result)
			if (result?.data?.book_keep_headers?.length === 0) {
				console.log('No data')
				tableData.value = []
				return
			} else {
				console.log('**** else', result.data.book_keep_headers)
				tableData.value = result.data.book_keep_headers.map((item) => {
					return {
						date: item.book_keep_date,
						documentNumber: item.document_number,
						companyId: item.customer_or_supplier_id,
						companyTitle: item.customer_or_supplier_title,
						paymentAmount: floatedCurrencyAddedNumber(
							item.payment_credit_amount,
						),
						type: item.transaction_type,
					}
				})
				console.log('tableData.value', tableData.value)
				bookKeepIdsArray.value = result.data.book_keep_headers.map((item) => {
					return item.book_keep_id
				})
				console.log('bookKeepIdsArray.value', bookKeepIdsArray.value)
			}
		})

		const { mutate: createNewReportHeader, onDone: onDoneHeaders } =
			useMutation(CreateCollectPaymentReportHeaderMutation, () => ({
				variables: {
					our_company: Store.getters.getUserCurrentCompany,
					report_date: dateformat(reportData.endingDate, 'yyyy-mm-dd'), // reportHeaders.reportDate,
					report_type: reportType.value,
				},
			}))
		const getReportType = (payload) => {
			switch (payload) {
				case 'collectedPaymentReport':
					return 'Inbetalningsjournal nr. '
				case 'payoutReport':
					return 'Utbetalningsjournal nr. '
				case 'setOffReport':
					return 'Övriga transaktionsjournal nr. '
				default:
					return 'Övriga transaktionsjournal nr. '
			}
		}
		onDoneHeaders((result) => {
			console.log('result', result)
			reportHeaders.ourCompany =
				result.data.insert_collect_payment_report_headers.returning[0].our_company
			reportHeaders.reportDate =
				result.data.insert_collect_payment_report_headers.returning[0].report_date
			reportHeaders.reportNumber =
				result.data.insert_collect_payment_report_headers.returning[0].report_number
			reportHeaders.reportType = getReportType(
				result.data.insert_collect_payment_report_headers.returning[0]
					.report_type,
			)
			reportNumber.value =
				result.data.insert_collect_payment_report_headers.returning[0].report_number
			console.log('reportHeaders', reportHeaders)
		})
		const bookKeepId = ref('')
		const reportNumber = ref(0)
		const { mutate: insertReportNumber, onDone: onDoneInsertReportNumber } =
			useMutation(UpdateBookKeepHeadersTableInsertReportNumberMutation, () => ({
				variables: {
					book_keep_id: bookKeepId.value,
					report_number: reportNumber.value,
				},
			}))
		onDoneInsertReportNumber((result) =>
			console.log('Report number is inserted', result),
		)
		const insertReportNumberPromise = () => {
			return new Promise((resolve, reject) => {
				if (bookKeepIdsArray.value !== null || undefined) {
					bookKeepIdsArray.value.forEach((item) => {
						bookKeepId.value = item
						insertReportNumber()
					})
					resolve(bookKeepIdsArray.value)
				} else {
					const reason = new Error('Data could not be fetched from database')
					reject(reason)
				}
			})
		}
		const disabledButton = ref(false)
		watchEffect(() => {
			if (tableData.value.length === 0) {
				disabledButton.value = true
			} else {
				disabledButton.value = false
			}
		})
		const createHeader = () => {
			disabledButton.value = true
			setTimeout(() => {
				disabledButton.value = false
			}, 1500)
			createNewReportHeader()
				.then(() => insertReportNumberPromise())
				.then(() => {
					Router.push({ name: 'GetCollectedPaymentsReport' })
				})
			console.log('reportHeaders.reportNumber', reportHeaders.reportNumber)
			console.log('reportHeaders.ourCompany', reportHeaders.ourCompany)
		}
		const firstDayOfWeek = 1
		return {
			reportData,
			reportHeaders,
			showWeekNumber,
			locale,
			reportType,
			createHeader,
			loading,
			tableData,
			columns,
			getData,
			refetch,
			radio,
			dateformat,
			firstDayOfWeek,
			disabledButton,
		}
	},
}
</script>

<style scoped>
.margin-top-15 {
	margin-top: 10px;
}
</style>
